var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUpWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5L11 2.5C11.7956 2.5 12.5587 2.81607 13.1213 3.37868C13.6839 3.94129 14 4.70435 14 5.5V9.5H19.66C19.9499 9.49672 20.2371 9.5565 20.5016 9.67522C20.7661 9.79393 21.0016 9.96873 21.1919 10.1875C21.3821 10.4063 21.5225 10.6638 21.6033 10.9423C21.6842 11.2207 21.7035 11.5134 21.66 11.8L20.28 20.8C20.2077 21.2769 19.9654 21.7116 19.5979 22.024C19.2304 22.3364 18.7623 22.5055 18.28 22.5H7M7 11.5V22.5M7 11.5H4C3.46957 11.5 2.96086 11.7107 2.58579 12.0858C2.21071 12.4609 2 12.9696 2 13.5V20.5C2 21.0304 2.21071 21.5391 2.58579 21.9142C2.96086 22.2893 3.46957 22.5 4 22.5H7",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpWhite);
export default __webpack_public_path__ + "static/media/thumbs-up-white.0d7bb0fef1802af533053508c62de4fb.svg";
export { ForwardRef as ReactComponent };